import { render, staticRenderFns } from "./featureFive.vue?vue&type=template&id=2de341f0&"
import script from "./featureFive.vue?vue&type=script&lang=js&"
export * from "./featureFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports